/* eslint-disable quotes */
import { Component } from '@angular/core';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { SaleBillDocumentEmitService } from '../credit-notes.service';
import { getTagColor } from '../../../../../../helpers/tag-color.helpers';

@Component({
  selector: 'pg-credit-notes-document',
  templateUrl: './credit-notes-document.component.html'
})
export class CreditNotesDocumentComponent extends TableActionsTemplate {
  idDocument: number;
  idDocumentToCancel: number;
  cancelCreditNoteDialog = false;

  constructor(private serviceBase: SaleBillDocumentEmitService) {
    super('', serviceBase);
  }

  ngOnInit(): void {
    this.table.settings = {
      title: 'Nota de Crédito',
      columns: [
        { header: 'Sucursal', field: 'branchStoreName' },
        { header: 'Pt.V.', field: 'pointSaleCode' },
        { header: 'Cliente', field: 'clientName' },
        { header: 'Voucher', field: 'typeVoucher', tag: 'tagStatus' },
        { header: 'Serie', field: 'serie' },
        { header: 'Correlative', field: 'correlative' },
        { header: 'Moneda', field: 'typeMoney' },
        { header: 'SubTotal', field: 'valueSale' },
        { header: 'IGV', field: 'mtoIGV' },
        { header: 'Total', field: 'mtoTaxSale' },
        { header: 'Fecha', field: 'issueAt' }
      ],
      filterColumns: true
    };
    this.table.actions = [
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      },
      {
        name: 'cancel-bill',
        icon: 'pi pi-times',
        class: 'p-button-rounded p-button-danger',
        pTooltip: 'Emitir'
      }
    ];
    this.initSubscriptions$();
  }

  async onReciveAction(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      if (action === 'see-details') {
        this.idDocument = data.id;
      } else if (action === 'cancel-bill') {
        this.idDocumentToCancel = data.id;
        this.cancelCreditNoteDialog = true;
      }
    }
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase.getData$().subscribe((data) => {
      data = data.map((item) => {
        item.tagStatusColor = getTagColor(item.typeVoucher);
        return item;
      });
      this.table.data = data;
    });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
